import asset from "./assets";

const tools = [
    { logo: asset.logoHTML, name: "HTML" },
    { logo: asset.logoCSS, name: "CSS" },
    { logo: asset.logoJavaScript, name: "JavaScript" },
    { logo: asset.logoTypeScript, name: "TypeScript" },
    { logo: asset.logoReact, name: "React" },
    { logo: asset.logoRedux, name: "Redux" },
    { logo: asset.logoNextjs, name: "Next.js" },
    { logo: asset.logoNodejs, name: "Node.js" },
    { logo: asset.logoExpressjs, name: "Express.js" },
    { logo: asset.logoMongoDB, name: "MongoDB" },
    { logo: asset.logoPHP, name: "PHP" },
    { logo: asset.logoLaravel, name: "Laravel" },
    { logo: asset.logoMySQL, name: "MySQL" },
    { logo: asset.logoThreejs, name: "Three.js" },
    { logo: asset.logoGSAP, name: "GSAP" },
    { logo: asset.logoSass, name: "Sass" },
    { logo: asset.logoTailwindcss, name: "Tailwind CSS" },
    { logo: asset.logoFigma, name: "Figma" },
    { logo: asset.logoMaterialUI, name: "Material UI" },
    { logo: asset.logoWordpress, name: "Wordpress" },
    { logo: asset.logoPython, name: "Python" },
    { logo: asset.logoAWS, name: "AWS" },
    { logo: asset.logoPostman, name: "Postman" },
    { logo: asset.logoJest, name: "Jest" },
    { logo: asset.logoCypress, name: "Cypress" },
    { logo: asset.logoGit, name: "Git" },
];

export default tools;